module.exports = __webpack_public_path__ + "static/media/assembly.abc644f8.jpg";